/*!

=========================================================
* Vue Argon ServiceDashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { authHeader } from './_helpers'
import { handleResponse } from './_helpers'
import { store } from './_store';
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import CircularCountDownTimer from "vue-circular-count-down-timer";
import moment from 'moment'
import VueSimpleSuggest from 'vue-simple-suggest'
import { FormTagsPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'
import { FormCheckboxPlugin } from 'bootstrap-vue'
import { FormRadioPlugin } from 'bootstrap-vue'
import { EmbedPlugin } from 'bootstrap-vue'
import { TooltipPlugin } from 'bootstrap-vue'
import { FormGroupPlugin } from 'bootstrap-vue'
import VueSwitches from 'vue-switches'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown,faSpinner,faCircleNotch,faPlus,
  faSearch,faTasks,faUserSecret,faBan,faSyncAlt,faAngleLeft,
  faAngleRight,faPencilAlt,faSave,faUsers,faFileAlt,
  faCertificate,faEye,faEllipsisV,faTimes,faCheck,
  faTrash,faChevronCircleRight,faSort,faCloudUploadAlt,
  faCloud,faUndoAlt,faPaperPlane,faArrowDown,faArrowUp,
  faArrowRight,faCircle,faFilter,faEyeSlash,faBars,faTh,
  faCalendarDay,faUndo,faChevronUp,faDesktop,faQrcode,faInfoCircle, faInfinity, faCreditCard, faBell} from '@fortawesome/free-solid-svg-icons'
import { faIdBadge,faTrashAlt,faWindowClose,faFile,faListAlt } from '@fortawesome/free-regular-svg-icons'
import { faWpforms } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { dom } from '@fortawesome/fontawesome-svg-core'
import VueQRCodeComponent from 'vue-qrcode-component'


dom.watch();
library.add(faUserSecret,faTasks,faSearch,faPlus,faChevronDown,
    faWpforms,faCircleNotch,faSpinner,faBan,faSyncAlt,faAngleLeft,
    faAngleRight,faPencilAlt,faSave,faUsers,faFileAlt,faCertificate,
    faIdBadge,faEye,faTrashAlt,faEllipsisV,faWindowClose,faTimes,
    faCheck,faTrash,faChevronCircleRight,faSort,faFile,faCloudUploadAlt,
    faCloud,faUndoAlt,faPaperPlane,faArrowDown,faArrowUp,faListAlt,
    faArrowRight,faCircle,faFilter,faEyeSlash,faBars,faTh,faCalendarDay,faUndo,faChevronUp,faDesktop,faQrcode,faInfoCircle,faInfinity,faCreditCard, faBell);


Vue.component('font-awesome-icon', FontAwesomeIcon);


moment.locale('de');

Vue.use(CircularCountDownTimer);
Vue.use(ArgonDashboard);
Vue.use(FormTagsPlugin);
Vue.use(FormSelectPlugin);
Vue.use(VueSwitches);
Vue.use(ListGroupPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormRadioPlugin);
Vue.use(EmbedPlugin);
Vue.use(TooltipPlugin);
Vue.use(FormGroupPlugin);


Vue.component('vue-simple-suggest', VueSimpleSuggest);
Vue.component('qr-code', VueQRCodeComponent)

Vue.config.productionTip = false;

Vue.filter('formatDateToDay', function(value) {
  if (value) {
    return moment(String(value)).format("DD. MMMM YYYY")
  }
});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format("LLLL")
  }
});

Vue.filter('formatDateShort', function(value) {
  if (value) {
    return moment(String(value)).format("LLL")
  }
});

Vue.filter('formatDateToNow', function(value) {
  if (value) {
    return moment(String(value)).toNow();
  }
});

Vue.filter('formatDateFromNow', function(value) {
  if (value) {
    return moment(String(value)).fromNow();
  }
});

Vue.filter('formatDateFromFormatToFormat', function(from, to, value) {
  if (value && from && to) {
    return moment(value,from).format(to)
  }
});

Vue.filter('differenceFromNowInSeconds', function(value){
  let a = moment(value);
  let b = moment();
  return a.diff(b,'seconds') // 86400000
});


Vue.mixin({
  methods: {
    authHeader() {
      return authHeader();
    },
    checkUserAgent(agent) {
      return navigator.userAgent.includes(agent)
    },
    handleResponse(response) {
      return handleResponse(response);
    },
    validEmail(email) {
      //var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPassword(password) {
      return (password) ? password.length > 7 : null;
    },
    allowMultipleInstances() {
      localStorage.removeItem('sg-browser-tab');
      sessionStorage.clear();
      this.$store.dispatch('tabwatchertimer/clear');
    },
    pushNotiMsg(msg) {
      // eslint-disable-next-line no-console
      console.log("PushNotiMsg:" + msg);
    },
    downloadFileAndShowDocumentViewer(id) {
      let head = this.authHeader();
      head['Accept'] = 'application/octet-stream';
      axios({
        url: process.env.VUE_APP_API_SERVER + '/document/show/' + id,
        headers: head,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        let url,type;
        url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
        type = response.data.type;
        this.$store.dispatch('document/show',{path: url, type: type});
        this.$store.dispatch('alert/clear');
      }, (error) => {
        this.$store.dispatch('alert/error',error);
      });
    },
    getUrlExtension(filter,sort,date) {
      let url = '';
      for (const [key, value] of Object.entries(filter)) {
        if (value !== null) url = url + key + '=' + value + '&';
      }
      for (const [key, value] of Object.entries(sort)) {
        if (value !== null) url = url + 'order%5B' + key + '%5D=' + value + '&'
      }

      for (const [key, value] of Object.entries(date)) {
        if (value !== null) {
          let date = moment(String(value));
          date.add(1,'day');
          url = url + key + '[before]=' + date.format("YYYY-MM-DD") + '&' + key + '[after]=' + value + '&'
        }
      }

      if(url.length > 1) url.slice(0, -1);

      return url;

    },
    }
  });


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
